import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  swiper;

  static values = {
    options: {
      type: Object,
      default: {},
    },
  };

  static targets = ['swiper'];

  get defaultOptions() {
    return {
      modules: [Navigation, A11y],
      a11y: {
        paginationBulletMessage: 'Aller à la slide n°{{index}}',
        slideLabelMessage: 'Slide n°{{index}} sur {{slidesLength}}',
        nextSlideMessage: 'Slide suivante',
        prevSlideMessage: 'Slide précédente',
        firstSlideMessage: 'Ceci est la première slide',
        lastSlideMessage: 'Ceci est la dernière slide'
      }
    };
  }

  connect() {
    this.swiper = new Swiper(this.swiperTarget, {
      ...this.defaultOptions,
      ...this.optionsValue,
    });
  }

  disconnect() {
    this.swiper?.destroy();
    this.swiper = undefined;
  }
}
